import React from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

export function ConfirmDialog({
  open, onOpenChange, title, description, confirmLabel = "Confirmer",
  destructive = false, loading = false, onConfirm,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="confirm-title">{title}</AlertDialogTitle>
          {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel" disabled={loading}>Annuler</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-accept"
            disabled={loading}
            onClick={(e) => { e.preventDefault(); onConfirm(); }}
            className={destructive
              ? "bg-red-600 hover:bg-red-700"
              : "bg-[#1E3D2B] hover:bg-[#2C5540]"}
          >
            {loading ? "…" : confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ConfirmDialog;
